import Api from "./api"
import Source from "./source"
import Device from "./device"
import App from "./app"
import _Event from "./event"
import Hls from "./hls"
import Rf from "./rf"
import Common from "./common"

class Tizen {
  constructor() {
    this._api = new Api()
    this._source = new Source()
    this._device = new Device()
    this._common = new Common()
    this._app = new App()
    this._event = new _Event()
    this._multicast = new Hls()
    this._RF = new Rf()
    this._hls = this._multicast
    this._vod = this._multicast
  }
}

export default new Tizen()
